import { api } from '../api/client';
import { ADMIN } from '../api/endpoints';

export const adminService = {
  userEngagement: (id) => api.get(ADMIN.USER_ENGAGEMENT(id)),
};
